<template>
  <div  :class="{ pasifCard: disable }">
     <div v-if="disable"  style="background: white;"><span style="color: red;">Bu öğe pasif olduğundan başvuru ekranında görüntülenmeyecektir. </span></div>
     <div :disabled="disable" :class="{ pasifCard: disable }">
         <v-alert
      border="top"
     
       colored-border
      :color="ayar.borderrenk.istek ? ayar.borderrenk.value : ''"
      
      elevation="2" :style="{ background : ayar.tabanrenk.istek ? ayar.tabanrenk.value : 'none' }" 
    >
  
       <div class="ql-editor" v-html="html"></div>

    <slot name="group">
      <!-- <small>Varsayılan footer</small> -->
    </slot>
      </v-alert>
     </div>
     
     <!-- <v-card :disabled="disable" :class="{ pasifCard: disable }"
  elevation="3">

</v-card> -->
      


    <!-- <v-card 
  elevation="3"
>
 <v-card-text >
   <div class="ql-editor" v-html="html"></div>
</v-card-text>
</v-card> -->



  </div>

</template>
<script>
import { htmlSF } from '@/plugins/FieldDataFormat.js'

export default {
  data() {
    return {
      value: "",
      label: "",
      html:"",
      disable:false
     

    }
  },
  props: {
    ayar: {
      // default: '{"title":"","description":""}',
      default() {
        return htmlSF;
      },
      type: Object
    },


  },
  methods: {
    dataBind(json) {
      //console.log("Vtext Json", json);
      // let ayarJson = JSON.parse(jsonStr);
      this.value = json.value;
      this.html=json.html;

    }
  },
  computed: {
 
    // a computed getter
    getAyar: function () {
      // `this` points to the vm instance
      return this.ayar;
    },
    // iç kullanım için modelValue (opsiyonel)
    // model: {
    //   get() {
    //     return this.value;
    //   },
    //   set(val) {
    //     this.value=val;
    //     console.log("Model SEt",val);
    //    // this.$emit('input', val); // v-model'e değer gönder
    //   }
    // }
    //     model: {
    //   prop: 'value',
    //   event: 'input'
    // },

  },
  created() {
    this.dataBind(this.ayar);
  },
  watch: {
    ayar: {
      immediate: true,
      handler(newVal, oldVal) {
        this.dataBind(newVal);    
      },
      deep: true
    },
    value(n, o) {
      this.$emit('input', n);

    },
  },

}
</script>
<style scoped>
.pasifCard{
  background-color: gray !important;
}
</style>